import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { connect } from 'react-redux';
import Wait4Me from '../../../components/Wait4Me';
import RangedDtPicker from '../../../components/RangedDtPicker';
import ColumnFilter from '../../../components/ColumnFilter';
import InvestTable from './../../../components/ns/InvestTable';
import moment from 'moment';

import BuSwitcher from './components/BuSwitcher';

import Pager from 'react-pager';

import {
  corperateColumnData,
  corperateSubColumnData,
  corperateTopInfoData,
  individualColumnData,
  individualSubColumnData,
  individualTopInfoData
} from './metadata';
import {
  getAlertHitsData,
  getInvestListData
} from '../../../redux/actions/ns/investigation';

import { dateTimeFormat } from '../../../util/GlobalConstant';

import style from './index.scss';
import { SearchText } from './components/SearchText/index';
import {
  AlertComponent,
  ClickableAlertComponent
} from './components/AlertComponent/index';
import { statusData } from '../../tm/investigation/metaUtils';
import { StatusFilterForNS } from '../../../components/StatusFilter/StatusFiltersForNS';

import { getItemFromLocalStorage } from '../../../util/localStorageUtils';

import { isUiResourceAvailable } from '../../../util/index';
import { convertDateInputToEpoch } from '../../../util/timezone';
import { getSelectedResources } from '../../../util/resourceManager';

const INDIVIDUAL_VIEW = 0;
const CORPORATE_VIEW = 1;

const ALL_ALERTS = 0;
const OPEN_ALERTS = 1;
const UNDER_INVESTIGATION_ALERTS = 2;
const CLOSED_ALERTS = 3;
const { nsUserManagementResourcesArray } = getSelectedResources();

export class Investigation extends React.Component {
  // eslint-disable-line react/prefer-stateless-function
  constructor(props) {
    super(props);

    let dateRange = {
      startDate: moment().subtract(30, 'days').add(1, 'days'),
      endDate: moment(),
      activeRangeNo: 2
    };

    try {
      const LCDateValue = localStorage.getItem('ns-listing-date');

      if (dateRange) {
        const storedDateRange = JSON.parse(LCDateValue);
        dateRange = {
          startDate: moment(storedDateRange.startDate, dateTimeFormat),
          endDate: moment(storedDateRange.endDate, dateTimeFormat),
          activeRangeNo: storedDateRange.activeRangeNo
        };
      }
    } catch (err) {
      console.log(err);
    }

    localStorage.removeItem('nsInvestTableFilter');
    this.searchTextRef = React.createRef();
    this.state = {
      activeStatusNo: 0,
      dateRange,
      investigation: this.props.investigation,
      tableFilterSetting: {},
      disabledFilters: [],
      activeBU: INDIVIDUAL_VIEW,
      isLoading: false,
      limit: 10,
      offset: 0,
      currentPage: 0,
      searchText: null
    };
  }

  componentDidMount() {
    this.refreshAlertList();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.investigation) {
      this.setState({
        ...this.state,
        investigation: nextProps.investigation,
        isLoading: nextProps.isLoading
      });
    }
  }

  onBUSwitchChange = (value) => {
    this.searchTextRef.current.value = '';
    const { dispatch } = this.props;
    localStorage.removeItem('nsInvestTableFilter');
    this.setState(
      {
        activeBU: value,
        activeStatusNo: 0,
        searchText: null
      },
      () => {
        this.refreshAlertList();
      }
    );
  };

  onDateChange = (startDate, endDate, rangeNo) => {
    this.searchTextRef.current.value = '';
    const updatedDateRange = {
      startDate,
      endDate,
      activeRangeNo: rangeNo
    };

    const storedDateRange = {
      startDate: startDate.format(dateTimeFormat),
      endDate: endDate.format(dateTimeFormat),
      activeRangeNo: rangeNo
    };

    localStorage.setItem('ns-listing-date', JSON.stringify(storedDateRange));

    this.setState(
      {
        ...this.state,
        dateRange: updatedDateRange,
        searchText: null,
        isLoading: true,
        currentPage: 0,
        activeStatusNo: 0
      },
      () => {
        this.refreshAlertList();
      }
    );
  };

  onLoadHits = (alertId) => {
    const { dispatch } = this.props;
    this.setState(
      {
        ...this.state,
        isLoading: true
      },
      () => {
        dispatch(getAlertHitsData({ alertId }));
      }
    );
  };

  // on page change
  onPageChanged = (newPage) => {
    const { activeBU, activeStatusNo } = this.state;
    this.setState(
      {
        ...this.state,
        currentPage: newPage
      },
      () => {
        const { dispatch } = this.props;
        const { startDate, endDate } = this.state.dateRange;

        if (dispatch) {
          if (activeStatusNo !== ALL_ALERTS) {
            let filter = '';
            switch (activeStatusNo) {
              case OPEN_ALERTS:
                filter = '0';
                break;
              case CLOSED_ALERTS:
                filter = '1';
                break;
              case UNDER_INVESTIGATION_ALERTS:
                filter = '3';
                break;
            }

            dispatch(
              getInvestListData({
                from: this.getDateFormated(startDate),
                to: this.getDateFormated(endDate),
                offset: newPage * 20,
                q: btoa(
                  JSON.stringify({
                    filter: [
                      { columnName: 'alertStatus', logic: '=', value: filter },
                      { columnName: 'alertType', logic: '=', value: activeBU }
                    ]
                  })
                )
              })
            );
          } else {
            dispatch(
              getInvestListData({
                from: this.getDateFormated(startDate),
                to: this.getDateFormated(endDate),
                offset: newPage * 20,
                q: btoa(
                  JSON.stringify({
                    filter: [
                      { columnName: 'alertType', logic: '=', value: activeBU }
                    ]
                  })
                )
              })
            );
          }
        }
      }
    );
  };

  onSearchClick = () => {
    const { searchText, dateRange, activeBU } = this.state;

    if (searchText && searchText.trim() !== '') {
      const { dispatch } = this.props;
      this.setState(
        {
          activeStatusNo: 0
        },
        () => {
          dispatch(
            getInvestListData({
              from: this.getDateFormated(dateRange.startDate),
              to: this.getDateFormated(dateRange.endDate),
              q: btoa(
                JSON.stringify({
                  filter: [
                    { columnName: 'alertId', logic: '=', value: searchText },
                    { columnName: 'alertType', logic: '=', value: activeBU }
                  ]
                })
              )
            })
          );
        }
      );
    } else {
      this.refreshAlertList();
    }
  };

  onSearchTextChange = (e) => {
    const searchText = e.target.value;
    this.setState({ searchText: searchText.trim() !== '' ? searchText : null });
  };

  onStatusFilterChange = (index) => {
    const { dispatch } = this.props;
    const { dateRange, activeBU } = this.state;
    this.searchTextRef.current.value = '';

    this.setState(
      {
        ...this.state,
        activeStatusNo: index,
        currentPage: 0,
        searchText: null
      },
      () => {
        if (dispatch) {
          if (index !== ALL_ALERTS) {
            let filter = '';
            switch (index) {
              case OPEN_ALERTS:
                filter = '0';
                break;
              case CLOSED_ALERTS:
                filter = '1';
                break;
              case UNDER_INVESTIGATION_ALERTS:
                filter = '3';
                break;
            }

            dispatch(
              getInvestListData({
                from: this.getDateFormated(dateRange.startDate),
                to: this.getDateFormated(dateRange.endDate),
                q: btoa(
                  JSON.stringify({
                    filter: [
                      { columnName: 'alertStatus', logic: '=', value: filter },
                      { columnName: 'alertType', logic: '=', value: activeBU }
                    ]
                  })
                )
              })
            );
          } else {
            dispatch(
              getInvestListData({
                from: this.getDateFormated(dateRange.startDate),
                to: this.getDateFormated(dateRange.endDate),
                q: btoa(
                  JSON.stringify({
                    filter: [
                      { columnName: 'alertType', logic: '=', value: activeBU }
                    ]
                  })
                )
              })
            );
          }
        }
      }
    );
  };

  onTableFilterChange = (filters) => {
    let disabledFilters = [];
    let tableFilterSetting = {};

    // Get deselected column data
    Object.keys(filters).forEach((key) => {
      let column = filters[key];
      let columnKeys = Object.keys(column);
      if (columnKeys && columnKeys.length > 0) {
        columnKeys.forEach((columnKey) => {
          if (!column[columnKey]) {
            disabledFilters.push(columnKey);
          }

          if (tableFilterSetting[key]) {
            //set 2d array to avoid the duplicated name in different group
            tableFilterSetting[key][columnKey] = column[columnKey];
          } else {
            tableFilterSetting[key] = {};

            tableFilterSetting[key][columnKey] = column[columnKey];
          }
        });
      }
    });

    localStorage.setItem(
      'nsInvestTableFilter',
      JSON.stringify(tableFilterSetting)
    );

    this.setState({
      ...this.state,
      disabledFilters,
      tableFilterSetting
    });
  };

  //prepare individual or corporate data
  getBUData = () => {
    const { activeBU } = this.state;
    const columnData =
      activeBU === INDIVIDUAL_VIEW ? individualColumnData : corperateColumnData;
    const subColumnData =
      activeBU === INDIVIDUAL_VIEW
        ? individualSubColumnData
        : corperateSubColumnData;
    const topInfoMetadata =
      activeBU === INDIVIDUAL_VIEW
        ? individualTopInfoData
        : corperateTopInfoData;
    return { columnData, subColumnData, topInfoMetadata };
  };

  getFilteredColumnData = (columnData) => {
    const { disabledFilters } = this.state;
    let filteredColumnData = [];
    if (disabledFilters && disabledFilters.length > 0) {
      // strip any deslected filters from columnData variable
      if (columnData && Array.isArray(columnData) && columnData.length > 0) {
        columnData.forEach((column) => {
          const group = column.group;
          let filteredGroup = [];

          if (group && Array.isArray(group) && group.length > 0) {
            group.forEach((subHeader) => {
              if (!disabledFilters.includes(subHeader.name)) {
                filteredGroup.push(subHeader);
              }
            });
          }

          const filteredColumn = {
            ...column,
            group: filteredGroup
          };
          filteredColumnData.push(filteredColumn);
        });
      }
    }
    return filteredColumnData;
  };

  getInvestTablePagerData = () => {
    const { investigation, dateRange, activeBU, currentPage } = this.state;

    const { authentication } = this.props;

    let tableData = investigation.alertList || [];
    const { columnData, subColumnData, topInfoMetadata } = this.getBUData();
    const filteredColumnData = this.getFilteredColumnData(columnData);
    const { currentFilterAlertCount } = this.getStatusFilterData();

    const isUsingUserManagement =
      getItemFromLocalStorage('user-management-enabled') === 'true';
    let isAllowedDetailsPage = isUsingUserManagement ? false : true;

    // confirm if using user management, if user has access to details page
    if (isUsingUserManagement) {
      if (
        authentication &&
        Array.isArray(authentication.data) &&
        authentication.data.length > 0
      ) {
        const listOfUiResources = authentication.data?.map((attributeItem) => {
          return attributeItem?.details?.resource?.resourceCode;
        });

        // true if user has access to a single resource in details page
        nsUserManagementResourcesArray.nsAlertDetails.forEach((uiResource) => {
          if (isUiResourceAvailable(uiResource, listOfUiResources)) {
            isAllowedDetailsPage = true;
          }
        });
      }
    }

    return (
      <div>
        <InvestTable
          theadData={
            filteredColumnData.length > 0 ? filteredColumnData : columnData
          }
          subTheadData={subColumnData}
          tbodyData={tableData}
          topInfoMetadata={topInfoMetadata}
          activeBU={activeBU}
          onLoadHits={this.onLoadHits}
          isClickable={isAllowedDetailsPage}
        />

        <Pager
          className={classnames('pull-right', style.pager)}
          total={Math.ceil(currentFilterAlertCount / 20) || 0}
          current={currentPage}
          visiblePages={5}
          onPageChanged={this.onPageChanged}
        />
      </div>
    );
  };

  getStatusFilterData = () => {
    const { investigation, activeStatusNo } = this.state;
    const alertCounts = investigation.alertCounts || {};
    const statusFilterData = {
      all: alertCounts['all'],
      open: alertCounts['open'],
      under_investigation: alertCounts['underInvestigation'],
      closed: alertCounts['closed']
    };
    let currentFilterAlertCount =
      statusFilterData[Object.keys(statusFilterData)[activeStatusNo]];
    return { currentFilterAlertCount, statusFilterData };
  };

  getTabContentBasedOnStatus = () => {
    const { investigation } = this.state;
    let tableData = investigation.alertList || [];
    if (investigation.error !== null) {
      return (
        <ClickableAlertComponent
          onAlertClick={this.refreshAlertList}
          alertDisplayText="Something went wrong, to try again,click"
        />
      );
    } else if (investigation.isLoading) {
      return (
        <AlertComponent
          alertColorClass="info"
          alertDisplayText="Loading, please wait..."
        />
      );
    } else if (
      (Array.isArray(investigation.alertList) &&
        investigation.alertList.length === 0) ||
      tableData.length === 0
    ) {
      return (
        <AlertComponent
          alertColorClass="info"
          alertDisplayText="No alerts existing for the date range or query selected."
        />
      );
    } else {
      return this.getInvestTablePagerData();
    }
  };

  getDateFormated = (date) => {
    return convertDateInputToEpoch(date, false);
  };

  refreshAlertList = () => {
    const { dispatch } = this.props;
    if (dispatch) {
      const { dateRange, activeBU } = this.state;

      let LCDateRange = null;
      try {
        LCDateRange = JSON.parse(localStorage.getItem('ns-listing-date'));
      } catch (err) {
        console.log(err);
      }

      dispatch(
        getInvestListData({
          from: LCDateRange
            ? this.getDateFormated(LCDateRange?.startDate)
            : this.getDateFormated(dateRange?.startDate),
          to: LCDateRange
            ? this.getDateFormated(LCDateRange?.endDate)
            : this.getDateFormated(dateRange?.endDate),
          q: btoa(
            JSON.stringify({
              filter: [{ columnName: 'alertType', logic: '=', value: activeBU }]
            })
          )
        })
      );

      this.setState({
        ...this.state,
        isLoading: true,
        offset: 0
      });
    }
  };

  render() {
    const {
      activeStatusNo,
      dateRange,
      activeBU,
      tableFilterSetting,
      isLoading
    } = this.state;

    const { columnData } = this.getBUData();
    const { statusFilterData } = this.getStatusFilterData();

    return (
      <div className={style.wrapper}>
        <div
          className={classnames('row', style.topFilter)}
          style={{ padding: '7px' }}>
          <div className={classnames('col-md-5')}>
            <RangedDtPicker
              startDate={moment(
                dateRange.startDate,
                'YYYY-MM-DDThh:mm:ss.000Z'
              )}
              endDate={moment(dateRange.endDate, 'YYYY-MM-DDThh:mm:ss.000Z')}
              activeRangeNo={dateRange.activeRangeNo}
              onDateChange={this.onDateChange}
            />
          </div>

          <div className="col-md-5 offset-md-2 text-right">
            <BuSwitcher
              activeBU={activeBU}
              onBUSwitchChange={this.onBUSwitchChange}
            />
          </div>
        </div>

        <div className={classnames('row', style.topFilter)}>
          <div className={classnames('col-md-4')}>
            <StatusFilterForNS
              filterData={statusFilterData}
              statusData={statusData}
              activeIndex={activeStatusNo}
              handleClick={this.onStatusFilterChange}
            />
          </div>

          <div className="col-md-5">{isLoading ? <Wait4Me /> : null}</div>

          <div className={classnames('col-md-1')}>
            <ColumnFilter
              filterGroupData={columnData}
              statusNo={activeStatusNo}
              userFilterSetting={tableFilterSetting}
              handleConfirm={this.onTableFilterChange}
            />
          </div>

          <div className={classnames('col-md-2')}>
            <SearchText
              ref={this.searchTextRef}
              onSearchTextChange={(e) => this.onSearchTextChange(e)}
              onSearchClick={(e) => this.onSearchClick(e)}
            />
          </div>
        </div>

        <div className={style.tabContent}>
          {this.getTabContentBasedOnStatus()}
        </div>
      </div>
    );
  }
}

Investigation.propTypes = {
  dispatch: PropTypes.func.isRequired
};

function mapStateToProps(state, ownProps = {}) {
  return {
    investigation: state.nsInvestigation,
    isLoading: state.app.isFetching,
    authentication: state.authentication
  };
}

function mapDispatchToProps(dispatch, ownProps = {}) {
  return {
    dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Investigation);
